<template>
  <!-- <div class="m-b-20"> -->
    <!-- <router-link to="/product/libs/batch/create?type=add" target="_blank">
      <a-button type="primary">新建批次</a-button>
    </router-link>
    <a-button class="m-l-15" @click='pageSearchChange'>刷新</a-button> -->
  <!-- </div> -->
    <a-form class="m-b-10" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="批次名称" name='batch_name'>
        <a-input v-model:value="search.batch_name" style="width:260px" placeholder="请输入批次名称进行搜索"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" name='product_name'>
        <a-input v-model:value="search.product_name" style="width:260px" placeholder="请输入商品名称进行搜索"></a-input>
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="onChange" />
      </a-form-item>
      <a-form-item label="商品编号" name='product_sn'>
        <a-input v-model:value="search.product_sn" style="width:260px" placeholder="请输入商品编号进行搜索"></a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
         <a-button type="primary" ghost @click='pageSearchChange' class="m-l-10">刷新</a-button>
      </a-form-item>
    </a-form>
  <div class="m-b-10"><span class="s_c999">没有找到所需的生产批次？</span>
        <a href="/product/batch/create?type=add" target="_blank" v-if="!goType">新建批次</a>
        <a v-else @click="openModal()">新建批次</a>
  </div>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' class="tableFixBox" :scroll="{ x: 'max-content'}">
    <template v-slot:product_name="{ record }">
      {{record.product_name}}
      <p class="s_c999">商品编号：{{record.product_sn}}</p>
    </template>
    <template v-slot:remark="{ record }">
      <p style="max-width:300px">{{record.remark || '-'}}</p>
    </template>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click='select(record)' v-if='!checkout' :ghost="!record.select">{{!record.select ? "选择":"已选择"}}</a-button>
      <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else >{{!record.select ? "选择":"已选择"}}</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  <div class="s_flex_center m-t-10" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getProductBatch } from "@/api/product";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
    start_time: "",
    end_time: "",
    page: 1,
    limit: 5,
    batch_name: "",
    product_name: "",
    product_sn:""
  };
  export default {
    name: "selectGoodBatch",
    components: {},
    props: {
      selectList:{
        type:Array
      },
      checkout:{
        type:Boolean
      },
      productId:{
        type:Number
      },
      productSkuSn:{
        type:String
      },
      goType:{
        type:Boolean,
        default:false
      }
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        total: 0,
        selectList:[],
        checkout:false,
        time:[]
      });
      let columns = [
      {
          title: "批次ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "批次名称",
          dataIndex: "batch_name",
          key: "batch_name",
        },
        {
          title: "商品名称",
          dataIndex: "product_name",
          key: "product_name",
          slots: { customRender: "product_name" },
        },
        {
          title: "规格",
          dataIndex: "product_sku_name",
          key: "product_sku_name",
          customRender:({record})=>{
            return record.product_sku_name ? record.product_sku_name:'单规格'
          } 
        },
        {
          title: "创建时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          slots: { customRender: "remark" },
        },
        {
          title: "操作",
          key: "action",
          width:120,
          fixed:"right",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");
      
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //单选
      const select = (e) => {
        data.value.map(item => item.select = false)
        if(e!=0){
          e.select = !e.select
        }
        emit("select", e);
      }
      //多选
      const checkBnt = (e) => {
        if (!e.select) {
          state.selectList.push(e);
        } else {
          var index = 0;
          state.selectList.forEach((v, k) => {
            if (v.id == e.id) {
              index = k;
            }
          });
          state.selectList.splice(index, 1);
        }
        e.select = !e.select
      }
      //多选确认
      const confirm = () =>{ 
        emit("select",state.selectList);
      }
      const initData = async () => {
        state.listLoading = true;
        try {
          let res = await getProductBatch({...search.value}).then(res => res.data).catch(error=>error)
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data;
            state.total = res.meta.total;
            if(state.selectList || state.selectList.length > 0){
              data.value.forEach(i=>{
                if( state.selectList.find(v=>{
                  return i.id == v.id
                })){
                  i.select=true
                }
              })
            }
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };

      const onChange = function(e){
           state.time = e;
           search.value.start_time = e[0];
           search.value.end_time = e[1];
      }

      const openModal = function(){
           emit('openModal',true)
      }

      onMounted(() => { 
        if(props.selectList){
          state.selectList = JSON.parse(JSON.stringify(props.selectList))
        }
        if(props.productId || props.productSkuSn ){
          search.value = { ...search.value, product_id: props.productId,product_sku_sn:props.productSkuSn || 0 };
        }
        initData()
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        select,
        checkBnt,
        confirm,
        onChange,
        openModal
      };
    },
  };
</script>
